import { FCX } from "@datassential/platform-ui-lib";
import './Section.scss';
import { ReactNode } from "react";
import cn from "classnames";

const FoodSection: FCX<{
    headerContent?: ReactNode;
}> = ({
    headerContent,
    children,
    style,
    className,
    testId,
}) => {
    return (
        <div
            className={cn(
                "FoodSection",
                className,
                !children && "is-no-content",
            )}
            data-testid={testId}
            style={style}
        >
            <div
                className="FoodSection__header"
                // data-testid="blockFoodSectionHeader"
            >
                {headerContent}
            </div>
            {children && (
                <div
                    className="FoodSection__content"
                    // data-testid="blockFoodSectionContent"
                >
                    {children}
                </div>
            )}
        </div>
    );
};

export default FoodSection;